<style lang="less">
	@import "../assets/css/main.less";
</style>
<template>
	<div class="mains">
		<div class="banner">

			<div class="w1100 clearfix text_wrap">
				<div class="text">
				<div class="first">
					<p>专注身份认证解决方案<span>全行业应用场景落地</span></p>
				</div>
				<div class="two">
					<div class="white_strip"></div>
					<p>identity<span>authentication</span></p>
				</div>
				</div>
			</div>
			<img src="../assets/img/banner1.jpg" />
		</div>
	</div>
</template>

<script>
export default {
	name:"mains",
	data() {
		return {

		};
	},
	created() {

	},
	methods:{

	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/main.vue